import { connect } from 'react-redux'
import React, { Component } from 'react'
import App from '../app/App'
import LandingPage from '../pages/landing/Landing'
import PricingPage from '../pages/landing/Pricing'
import Cookies from 'js-cookie'

class Root extends Component {
  render() {
    const { params, location, userName } = this.props
    params.query = { ...location.query }
    switch (params.view || null) {
      case 'clipper':
      case 'settings':
      case 'joiner':
      case 'videos':
      case 'video':
      case 'edit':
      case 'stats':
      case 'report':
      case 'dmca':
      case 'buildembed':
      case 'payments':
        break
      case 'pricing':
        return (<PricingPage viewParams={params} />)
      case null:
        if (params.splat) {
          params.view = 'clipper'

          let url = params.splat
          let first = true
          for (const name in params.query) {
            if (first) {
              url += '?'
            } else {
              url += '&'
            }
            url += `${name}=${params.query[name]}`
            first = false
          }

          params.query.url = url

          break
        }
        if (Cookies.get('user_name') || Cookies.get('dashboard')) {
          params.view = 'videos'
          break
        }
        return (<LandingPage viewParams={{ ...params, query: location.query }} />)
      default:
        break
    }
    return (<div className='s_p_a'><App viewParams={params} key='app' /></div>)
  }
}

export default connect()(Root)
